import React, { useEffect, useState } from 'react';
import { CheckCircleIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { LoadingSpinner } from '../components/LoadingSpinner';
export function BookingProcessingScreen() {
  const navigate = useNavigate();
  const [isProcessing, setIsProcessing] = useState(true);
  useEffect(() => {
    // Simulate processing
    const timer = setTimeout(() => {
      setIsProcessing(false);
      // Navigate to bookings populated after showing success
      setTimeout(() => {
        navigate('/bookings/populated');
      }, 1500);
    }, 2000);
    return () => clearTimeout(timer);
  }, [navigate]);
  if (isProcessing) {
    return <div className="h-screen w-full flex flex-col items-center justify-center bg-white" data-id="element-375">
        <LoadingSpinner data-id="element-376" />
        <p className="text-lg text-[#1f5070] mt-6 animate-pulse" data-id="element-377">
          Processing your booking
          <span className="inline-block w-12 text-left" data-id="element-378">
            <span className="animate-[pulse_1.5s_ease-in-out_infinite]" data-id="element-379">.</span>
            <span className="animate-[pulse_1.5s_ease-in-out_0.2s_infinite]" data-id="element-380">
              .
            </span>
            <span className="animate-[pulse_1.5s_ease-in-out_0.4s_infinite]" data-id="element-381">
              .
            </span>
          </span>
        </p>
      </div>;
  }
  return <div className="h-screen w-full flex flex-col items-center justify-center bg-white animate-fade-in" data-id="element-382">
      {/* Success Animation */}
      <div className="relative" data-id="element-383">
        <div className="w-32 h-32 bg-[#43A047] rounded-full flex items-center justify-center animate-scale-in" data-id="element-384">
          <CheckCircleIcon className="w-20 h-20 text-white" data-id="element-385" />
        </div>
        {/* Confetti effect */}
        <div className="absolute inset-0 pointer-events-none" data-id="element-386">
          {[...Array(12)].map((_, i) => <div key={i} className="absolute w-2 h-2 rounded-full animate-float-gentle" style={{
          backgroundColor: ['#c7f61e', '#3dc7e3', '#FFB300'][i % 3],
          left: `${50 + Math.cos(i * Math.PI * 2 / 12) * 80}%`,
          top: `${50 + Math.sin(i * Math.PI * 2 / 12) * 80}%`,
          animationDelay: `${i * 0.1}s`
        }} data-id="element-387" />)}
        </div>
      </div>

      <h1 className="text-3xl font-bold text-[#1f5070] mt-8 animate-slide-up" data-id="element-388">
        Booking Confirmed!
      </h1>
      <p className="text-lg text-[#666666] mt-2 animate-slide-up" data-id="element-389">
        Redirecting to your bookings...
      </p>
    </div>;
}